import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import ContentArea from 'components/common/ContentArea';

import { SectionBlockContentProps } from './interfaces';

import useStyles from './style';

const SectionBlockContent: FC<PropsWithChildren<SectionBlockContentProps>> = ({
  isShown,
  children,
  className,
  toggleShow,
}) => {
  const classes = useStyles();

  const handleClick = () => {
    !isShown && toggleShow();
  };

  return (
    <ContentArea
      onClick={handleClick}
      className={classNames(
        'sectionBlockContent',

        classes.sectionBlockContent,
        className
      )}
    >
      {children}
    </ContentArea>
  );
};

export default SectionBlockContent;
